import moment from 'moment';
import apolloClient from 'store/apolloClient';
import * as services from 'modules/appointmentsManagement/services/fetchTimeSlots';
import apiCall from 'shared/utils/apiCall';
import createAsyncAction from 'shared/utils/createAsyncAction';
import errorAction from 'shared/utils/errorAction';
import createAction from './index';

export const FETCH_TIME_SLOTS = createAsyncAction(createAction('FETCH_TIME_SLOTS'));
export const FETCH_CALENDAR_TIME_SLOTS = createAsyncAction(createAction('FETCH_CALENDAR_TIME_SLOTS'));

export const fetchTimeSlots = (contractId, momentDate, momentEndDate, providerId, appointmentId = null) => dispatch => {
  dispatch({ type: FETCH_TIME_SLOTS.pending });

  const currDay = moment();
  const startDate = momentDate.clone();
  const endDate = momentEndDate ? momentEndDate.clone() : moment();
  const isSameDate = momentDate.isSame(currDay, 'day');
  const fromTime = isSameDate ? currDay : startDate.startOf('day');
  const isSameEndDate = momentEndDate && momentEndDate.isSame(momentDate, 'day');

  const filter = {
    from: fromTime.valueOf(),
    to: momentEndDate
      ? isSameEndDate
        ? startDate.endOf('day').startOf('minute').valueOf()
        : endDate.endOf('day').valueOf()
      : startDate.add(1, 'day').startOf('day').valueOf(),
  };

  const apiCallParams = {
    query: services.FETCH_TIME_SLOTS,
    fetchPolicy: 'no-cache',
    variables: {
      contractId,
      timeRange: filter,
      providerId: providerId === 'PROVIDERS_GROUP' ? null : providerId,
      appointmentId,
    },
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then((response) => {
      const timeSlots = response.data.getTimeSlots.timeSlots.filter(item => (item.to - item.from) >= 60000);

      return dispatch({
        type: FETCH_TIME_SLOTS.success,
        payload: timeSlots,
      });
    })
    .catch((err) => {
      dispatch(errorAction(FETCH_TIME_SLOTS.failure, err));

      throw err;
    });
};

export const fetchCalendarTimeSlots = (contractId, momentDate, providerId, appointmentId = null) => dispatch => {
  dispatch({ type: FETCH_CALENDAR_TIME_SLOTS.pending });

  const filter = {
    from: momentDate.valueOf(),
    to: momentDate.clone().add(1, 'month').valueOf(),
  };

  const apiCallParams = {
    query: services.FETCH_TIME_SLOTS,
    fetchPolicy: 'no-cache',
    variables: {
      contractId,
      timeRange: filter,
      providerId: providerId === 'PROVIDERS_GROUP' ? null : providerId,
      appointmentId,
      mode: 'MERGE_ADJACENT',
    },
  };

  return apiCall(apolloClient.query, apiCallParams)
    .then((response) => {
      const timeSlots = response.data.getTimeSlots.timeSlots.filter(item => (item.to - item.from) >= 60000);

      return dispatch({
        type: FETCH_CALENDAR_TIME_SLOTS.success,
        payload: timeSlots,
      });
    })
    .catch((err) => {
      dispatch(errorAction(FETCH_CALENDAR_TIME_SLOTS.failure, err));

      throw err;
    });
};
